import { useEffect, useState } from "react";

interface SelectFieldProps {
  value: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  label?: string;
}

export default function SelectField({ value, onChange, options, label }: SelectFieldProps) {
  const [open, setOpen] = useState(false);
  const current = options.find((item) => item.value === value);

  useEffect(() => {
    if (!open) return undefined;
    const close = () => setOpen(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, [open]);

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      {label && <span className="mr-2 text-xs text-foreground-500">{label}</span>}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex items-center gap-2 rounded-full border border-background-300/80 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition hover:border-primary-300"
      >
        <span>{current ? current.label : "请选择"}</span>
        <i className={`ri-arrow-down-s-line text-sm transition ${open ? "rotate-180" : ""}`}></i>
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-2 min-w-[140px] animate-scale-in overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-sm">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-3 py-2 text-left text-xs transition hover:bg-primary-50 ${
                option.value === value ? "text-primary-600" : "text-foreground-600"
              }`}
            >
              {option.label}
              {option.value === value && <i className="ri-check-line"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}